import React from 'react';
import moment from 'jalali-moment';

/*
    - ihoDesignSystem
*/
import { Box, Calendar, Grid, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import CalendarSVG from '../../../assets/images/help-desk/calendar.svg';

const ModifyDate = ({ requestType, selectedReserve, sendRequestStatusProps, modifyDateProps }) => {

    /*
        - defaultData
    */
    const [modifyDate, setModifyDate] = React.useState({ 0: '', 1: '' });

    /*
        - toggleCaldendar
    */
    const toggleCaldendar = (event, calendar) => {
        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }

    /*
        - handleModifyDate
    */
    const handleModifyDate = (date, id) => {
        setModifyDate(prev => ({ ...prev, [id]: date }));
    }

    React.useEffect(() => {
        let keys = Object.keys(modifyDate);
        let sendRequestStatus = false;
        keys.forEach((obj) => {
            if (modifyDate[obj] !== '') {
                sendRequestStatus = true;
                modifyDateProps(modifyDate);
            }
        });
        sendRequestStatusProps(sendRequestStatus);
    }, [modifyDate]);

    React.useEffect(() => {
        setModifyDate({ 0: '', 1: '' });
    }, [requestType]);

    return (

        <React.Fragment>

            {requestType.split(',')[1] === 'modifyDate' && requestType.split(',')[3] === 'selectReserve' && requestType.split(',')[4] === undefined &&
                <Box
                    className={`w-100 my-lg mb-0 border-solid-top border-medium`}>
                    <Typography
                        className={`py-md`}
                        component='h5'>
                        تاریخ ورود و خروج
                    </Typography>
                    <Box
                        className={`my-sm mt-0 rounded-sm`}
                        ms={{
                            backgroundColor: 'var(--gray-medium)',
                            opacity: '0',
                            animation: 'reserveAnimation 0.5s linear',
                            animationDelay: '1s',
                            animationFillMode: 'forwards',
                        }}>
                        <Grid>
                            <Grid.Wrapper>
                                <Grid.Item
                                    className={`position-relative`}
                                    size='col-6'>
                                    <Box
                                        onClick={(event) => toggleCaldendar(event, 'checkInDate')}>
                                        <TextField
                                            variant='filled'
                                            label='تاریخ ورود'
                                            icon={CalendarSVG}
                                            value={modifyDate[0] === '' ? Object.keys(selectedReserve).length > 0 && moment(selectedReserve.arrivalDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') : modifyDate[0]} />
                                        <Box
                                            className={`d-none calendar checkInDate position-absolute`}
                                            ms={{
                                                width: 'auto',
                                                bottom: '8px',
                                                left: '8px',
                                                zIndex: '1',
                                                '& .calendar_wrapper__xJjmm': {
                                                    padding: 'var(--sizing-xs)'
                                                }
                                            }}>
                                            <Calendar
                                                onChange={(value) => handleModifyDate(value, '0')} />
                                        </Box>
                                    </Box>
                                </Grid.Item>
                                <Grid.Item
                                    className={`position-relative`}
                                    size='col-6'>
                                    <Box
                                        onClick={(event) => toggleCaldendar(event, 'checkOutDate')}>
                                        <TextField
                                            variant='filled'
                                            label='تاریخ خروج'
                                            icon={CalendarSVG}
                                            value={modifyDate[1] === '' ? Object.keys(selectedReserve).length > 0 && moment(selectedReserve.exitDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') : modifyDate[1]} />
                                        <Box
                                            className={`d-none calendar checkOutDate position-absolute`}
                                            ms={{
                                                width: 'auto',
                                                bottom: '8px',
                                                right: '8px',
                                                zIndex: '1',
                                                '& .calendar_wrapper__xJjmm': {
                                                    padding: 'var(--sizing-xs)'
                                                }
                                            }}>
                                            <Calendar
                                                onChange={(value) => handleModifyDate(value, '1')} />
                                        </Box>
                                    </Box>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Box>
            }

        </React.Fragment>

    );

}

export default ModifyDate;